import Vue from 'vue'
import VueI18n from 'vue-i18n'

const cn = require('./lang/cn')

Vue.use(VueI18n)
export default new VueI18n({
  locale: 'CN',
  messages: {
    'CN': require('./lang/cn'),
    'EN': require('./lang/en'),
    'RU': require('./lang/ru')
  }
})



// WEBPACK FOOTER //
// ./src/assets/utils/i18n.js